import ChatPage from './containers/ChatPageContainer'

export default ChatPage